import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { QueryClient, QueryClientProvider } from 'react-query'
import routes from '../routes/index'
import '../styles/core.scss'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true
    }
  }
})

export default class Root extends Component {
  componentWillMount() {
    let i = localStorage.length
    while (i-- > 0) {
      let key = localStorage.key(i)
      if (key.includes('reduxPersist')) {
        localStorage.removeItem(key)
      }
    }
  }

  render() {
    const { store, history } = this.props

    return (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router history={history} routes={routes} />
        </Provider>
      </QueryClientProvider>
    )
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/Root.js